module.exports = __webpack_public_path__ + "img/addBookcase.802e053f.svg";